import React, { FunctionComponent, useContext } from 'react';
import Image from 'next/image';
import { useRouter } from 'next/router';
import { Box, Heading } from '@wix/design-system';
import { useTranslation } from '@wix/wix-i18n-config';
import { clickOnAnswer } from '@wix/bi-logger-customer-care-data/v2';
import { Breadcrumbs } from '../Breadcrumbs';
import { RenderHTML } from '../RenderHTML';
import { DATA_HOOKS } from '../../dataHooks';
import { Context } from '../../context';
import { useBI } from '../../hooks/useBI';
import { BI } from '../../constants';
import css from './index.module.scss';

export type ContactSupportProps = {
  searchMethod: string;
};

export const CHATBOT_URL = 'https://www.wix.com/contact';

export const ContactSupport: FunctionComponent<ContactSupportProps> = ({ searchMethod }) => {
  const { searchSessionId } = useContext(Context);
  const { t } = useTranslation();
  const { locale, query: { term } } = useRouter();
  const { sendBIEvent } = useBI();
  const breadcrumbItems = [
    { id: 'search-results', label: t('search-results-page.breadcrumb') },
  ];

  const onClick = async (e: React.MouseEvent<HTMLElement>) => {
    if ((e.target as HTMLAnchorElement).href.startsWith(CHATBOT_URL)) {
      await sendBIEvent(clickOnAnswer({
        clicked_item_type: 'summarized_answer_hyperlink',
        summarized_answer_type: 'support request',
        clicked_url: CHATBOT_URL,
        question: term as string,
        search_session_Id: searchSessionId,
        search_method: searchMethod,
        kb_lang: locale,
        source_name: BI.SOURCE_NAMES.SEARCH_RESULTS,
        search_result_selection: BI.SEARCH_RESULT_SELECTION.FULL_SEARCH_RESULTS_LIST
      }));
    }
  };

  return (
    <Box direction='vertical' dataHook={DATA_HOOKS.CONTACT_SUPPORT}>
      <Breadcrumbs breadcrumbItems={breadcrumbItems} />
      <Box className={css.wrapper} gap='3' direction='vertical'>
        <Heading size='extraLarge' className={css.title}>{t('search-results-page.gen-answer.contact-support.title')}</Heading>
        <Box className={css.body} align='space-between'>
          <RenderHTML onClick={onClick} html={t('search-results-page.gen-answer.contact-support.body')} />
          <Image src='https://static.parastorage.com/services/kb-client-nextjs/dist/public/images/search-results/contact-support.svg' alt='contact-support' width='120' height='120' />
        </Box>
      </Box>
    </Box>
  );
};
